import 'jquery';

export default new class ff {

    //檢查XXX，如果XXX已經變化就執行XXX的函式
    delayExecute(check, proc, chkInterval) {
        //default interval = 500ms
        var x = chkInterval || 500;
        var hnd = window.setInterval(function () {
            //if check() return true, 
            //stop timer and execute proc()
            if (check()) {
                window.clearInterval(hnd);
                return proc();
            }
        }, x);
    }

    // getParameter(queryString, parameterName) {

    //     var queryString = window.top.location.search.substring(1);

    //     // Add "=" to the parameter name (i.e. parameterName=value)
    //     var parameterName = parameterName + "=";
    //     if (queryString.length > 0) {
    //         // Find the beginning of the string
    //         begin = queryString.indexOf(parameterName);
    //         // If the parameter name is not found, skip it, otherwise return the value
    //         if (begin != -1) {
    //             // Add the length (integer) to the beginning
    //             begin += parameterName.length;
    //             // Multiple parameters are separated by the "&" sign
    //             end = queryString.indexOf("&", begin);
    //             if (end == -1) {
    //                 end = queryString.length
    //             }
    //             // Return the string
    //             return unescape(queryString.substring(begin, end));
    //         }
    //         // Return "null" if no parameter has been found
    //         return "null";
    //     }
    // }

    isJson(str)
    {
        if (typeof str == 'object') {
            return true;
        }

        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }

        return true;
    }

    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

}